import { useState } from 'react';

//interfaces
import { INotificationBar, defaultSettings } from '../../../elements/languages/NotificationBar';
import { LanguageTabs } from '@/interfaces/languages';



export const UseLanguages = () => {
    const [quickTranslateModal, setQuickTranslateModal] = useState<boolean>(false);
    const [notification, setNotification] = useState<INotificationBar>(defaultSettings)
    const [dctEnabled, setDctEnabled] = useState<boolean>(false);
    const [quickTranslateDisabled, setQuickTranslateDisabled] = useState<boolean>(false);
    const [selectedTab, setSelectedTab]= useState<LanguageTabs>(LanguageTabs.language);

    function toggleNotification(bar:INotificationBar){
        // Slight delay to allow browser to add scrollbar space back
        setTimeout(() => {
            
            if (!notification.show && bar.show){
                setNotification(bar)
    
                // Delay close
                setTimeout(() => {    
                    setNotification(defaultSettings)
                }, 3000);
            }
        }, 250);
    }

    return {
        quickTranslateModal,
        setQuickTranslateModal,
        dctEnabled,
        setDctEnabled,
        quickTranslateDisabled,
        setQuickTranslateDisabled,
        toggleNotification,
        notification,
        selectedTab,
        setSelectedTab
    }
}